import { render, staticRenderFns } from "./ScoringStep.vue?vue&type=template&id=07a7fbc8&scoped=true"
import script from "./ScoringStep.vue?vue&type=script&lang=js"
export * from "./ScoringStep.vue?vue&type=script&lang=js"
import style0 from "./ScoringStep.vue?vue&type=style&index=0&id=07a7fbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a7fbc8",
  null
  
)

export default component.exports